import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import ShortTermImg1 from '../../assest/Rental1-1.png';
import ShortTermImg2 from '../../assest/Rental2.png';
import ShortTermImg3 from '../../assest/Rentals-3.png';

const shortTermList = [
  {
    name: "1-Day Rental",
    image: ShortTermImg1,
    specs: "Perfect for quick, urgent tasks.",
    description: "Designed for clients needing equipment or professionals for just a single day.",
  },
  {
    name: "2-3 Day Rental",
    image: ShortTermImg2,
    specs: "Flexible and efficient short project solutions.",
    description: "Ideal for weekend projects or brief maintenance work without long-term contracts.",
  },
  {
    name: "4-6 Day Rental",
    image: ShortTermImg3,
    specs: "Extended short-term use at better rates.",
    description: "Great for week-long jobs with reduced pricing and full service support.",
  },
];

const translations = {
  gb: {
    heading: "Short-Term Services",
    introText: "Explore our quick rental options for short-duration needs.",
    categoriesTitle: "Short-Term Options",
    featuredTitle: "Flexible Short-Term Plans",
    featuredDescription: "Designed for flexibility, speed, and efficiency—rent only what you need, when you need it.",
  },
  sa: {
    heading: "الخدمات قصيرة الأجل",
    introText: "اكتشف خيارات الإيجار السريعة لتلبية احتياجاتك قصيرة المدى.",
    categoriesTitle: "خيارات قصيرة الأجل",
    featuredTitle: "خطط قصيرة الأجل مرنة",
    featuredDescription: "مصممة من أجل المرونة والسرعة والكفاءة – استأجر فقط ما تحتاجه عند الحاجة.",
  },
};

const ShortTerm = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={shortTermList}
      language={language}
    />
  );
};

export default ShortTerm;
